import getAndPopulateSuggestedContacts from 'owa-recipient-common/lib/actions/getAndPopulateSuggestedContacts';
import { action } from 'satcheljs/lib/legacy';
export default action('setIsSuggesting')(function setIsSuggesting(viewState, isSuggesting, queryString) {
    if (queryString === void 0) { queryString = ''; }
    viewState.isSuggesting = isSuggesting;
    viewState.isPopupShown = isSuggesting;
    if (!isSuggesting) {
        // Reset the viewState
        viewState.queryString = '';
        viewState.isSearching = false;
        viewState.hasSearchedDirectory = false;
    }
    else {
        if (queryString) {
            viewState.queryString = queryString;
        }
        else {
            getAndPopulateSuggestedContacts(viewState.recipientsShown);
        }
    }
});
//# sourceMappingURL=setIsSuggesting.js.map